export default function CerrarPedidoButton({ onClick, loading }) {
  return (
    <button
      onClick={onClick}
      disabled={loading}
      className="text-white font-semibold flex items-center justify-center gap-2 flex-1 min-w-0 h-12 px-4 rounded-full transition-all duration-200 ease-out active:scale-[0.98] hover:brightness-110"
      style={{
        backgroundColor: '#0071e3',
        border: 'none',
        cursor: loading ? 'wait' : 'pointer',
        fontSize: '14px',
        fontFamily: '"Public Sans", sans-serif',
        letterSpacing: '-0.01em',
        opacity: loading ? 0.7 : 1,
        minWidth: 'max-content',
        whiteSpace: 'nowrap',
      }}
    >
      {loading ? (
        <div
          style={{
            width: '16px',
            height: '16px',
            border: '2px solid rgba(255,255,255,0.3)',
            borderTop: '2px solid #fff',
            borderRadius: '50%',
            animation: 'cerrarSpin 1s linear infinite',
          }}
        />
      ) : null}
      {loading ? 'Cerrando...' : 'Cerrar'}
      <style>{`
        @keyframes cerrarSpin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </button>
  );
}
